import React, { createContext, useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions(): {
  width: number;
  height: number;
} {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const MaximizerContext = createContext({
  hiddenState: false,
  windowHeight: 0,
  footerHeight: 0,
  // eslint-disable-next-line
  hideFooter: (hide: boolean) => {},
  // eslint-disable-next-line
  setFooterHeight: (newHeight: number) => {}
});
const { Provider } = MaximizerContext;

const MaximizerProvider: React.FC = (props) => {
  const [hiddenState, setFooterHideState] = useState<boolean>(false);
  const [footerHeight, setFooterHeight] = useState<number>(0);
  const { height } = useWindowDimensions();

  const hideFooter = (hide: boolean) => {
    setFooterHideState(hide);
  };

  return (
    <Provider value={{ hiddenState, setFooterHeight, hideFooter, windowHeight: height, footerHeight }}>
      {props.children}
    </Provider>
  );
};

export { MaximizerProvider, MaximizerContext };
